// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  // API_URL: "https://t.api.testing.eirc.app/meglobe/v1.0",
  // API_URL: "https://api.eirc.app/meglobe/v1.0", // 正式環境
   API_URL: "https://api.testing.eirc.app/meglobe/v1.0", // 測試環境
  // API_URL: "http://163.18.42.222:8080/meglobe/v1.0",
  // API_URL: "http://localhost:8080/meglobe/v1.0",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
